// extracted by mini-css-extract-plugin
export default {"boton":"CausaReaccionListaScreen_boton__oij+M","containerTable":"CausaReaccionListaScreen_containerTable__4VQ-Y","subtitulo":"CausaReaccionListaScreen_subtitulo__F5CHq"};